/* eslint-disable import/no-unused-modules */
import Skeleton from '@mui/material/Skeleton';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import ContestJumbotron from '../components/About/Contests/ContestJumbotron';
import Footer from '../components/General/Footer';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import { GET_MINIMAL_POSTS } from '../helpers/graphql/posts';
import ssrGraphQLClient from '../helpers/ssrGraphQLClient';
import withApollo from '../lib/withApollo';

const TopicCarousel = dynamic(
  () => import('../components/FrontPage/TopicCarousel'),
  {
    loading: () => (
      <div className="pt-3 ml-5 mr-5">
        <Skeleton variant="rectangular" width="100%" height={400} />
      </div>
    ),
    ssr: false,
  },
);

const ContestPage = ({ runningContests, pastContests }) => {
  const [webpSupport, setWebpSupport] = useState(undefined);

  useEffect(() => {
    setWebpSupport(isWebpSupported());
  }, []);

  return (
    <>
      <Head
        title="TravelFeed Contests: Participate and earn cryptocurrency!"
        description="Participate in TravelFeed travel writing contests and get paid to travel the world. Become a travel blogger, join the TravelFeed community and earn cryptocurrency!"
      />
      <Header active="contests" subheader="Contests" />
      <ContestJumbotron />
      {runningContests &&
        runningContests.posts &&
        runningContests.posts.length > 0 && (
          <div className="container pt-3 text-center">
            <TopicCarousel
              carouselTopic={runningContests}
              webpSupport={webpSupport}
              isLargeItem
            />
          </div>
        )}
      <div className="container pt-3">
        <TopicCarousel
          carouselTopic={pastContests}
          webpSupport={webpSupport}
          noMore
        />
      </div>
      <Footer />
    </>
  );
};

export async function getStaticProps() {
  const runningContests = await ssrGraphQLClient(GET_MINIMAL_POSTS, {
    limit: 12,
    useBlacklist: false,
    onlyRunningContests: true,
  });
  runningContests.title = 'Running contests';
  const pastContests = await ssrGraphQLClient(GET_MINIMAL_POSTS, {
    limit: 12,
    useBlacklist: false,
    onlyRunningContests: false,
    orderby: 'createdAt',
  });
  pastContests.title = 'Past contests';
  return {
    props: { runningContests, pastContests },
  };
}

export default withApollo(ContestPage);
